module.exports = __webpack_public_path__ + "img/SBIT.aa4603e6.png";